import { useState, useEffect } from 'react'

export function useTheme() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') return true
    const stored = localStorage.getItem('nailartpro-theme')
    if (stored) return stored === 'dark'
    return true // DEFAULT: dark mode
  })

  useEffect(() => {
    const root = document.documentElement
    if (isDark) {
      root.classList.add('dark')
      localStorage.setItem('nailartpro-theme', 'dark')
    } else {
      root.classList.remove('dark')
      localStorage.setItem('nailartpro-theme', 'light')
    }
  }, [isDark])

  const toggle = () => setIsDark((prev) => !prev)

  return { isDark, toggle }
}
